export const GET_SPOTLIGHT = 'GET_SPOTLIGHT';
export const SET_SPOTLIGHT = 'SET_SPOTLIGHT';
